<template>
  <main class="main">
    <v-row>
      
      <v-col cols="12" style="background-color: #f5f5f5">
        <v-card class="pa-5" shaped>
          <v-row>
            <v-col cols="12">
              <v-card-title class="headline orange text-white">
                  <v-icon color="white mdi-24px">mdi-package-variant-closed</v-icon>
                  <v-divider class="mx-4" vertical></v-divider>
                 Datos del Proveedor
                </v-card-title>
              <v-card class="pa-2" elevation="0" color="brown lighten-5" outlined>
                <v-card-text>
                  <!-- <strong class="cliente">Datos del Proveedor</strong> -->
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                          v-model="editedItem.idestablecimiento"
                          :items="getEstablecimientos"
                          item-text="nombrecomercial"
                          item-value="idestablecimiento"
                          outlined
                          dense
                          @change="setIdEstablecimiento"
                          label="Seleccione Establecimiento"
                        ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="8">
                      <v-text-field
                        dense
                        v-model="editedItemProveedor.nit"
                        label="Nit"
                        @change="buscarCliente"
                      ></v-text-field>
                      <v-text-field
                        dense
                        v-model="editedItemProveedor.nombre"
                        label="Nombre Proveedor"
                      ></v-text-field>
                      <v-text-field
                        dense
                        v-model="editedItemProveedor.direccion"
                        label="Dirección"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-select
                        dense
                        v-model="editedItem.documento"
                        :items="tipodocumentos"
                        label="Tipo documento"
                        
                      ></v-select>
                      <v-text-field
                        dense
                        v-model="editedItem.serie"
                        label="Serie"
                      ></v-text-field>
                      <v-text-field
                        dense
                        v-model="editedItem.numero"
                        label="Número Factura"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="8">
                      <v-btn
                          class="text-white"
                          color="red"
                          style="text-decoration: none"
                          @click="createCliente"
                          v-if="!proveedorEncontrado"
                        > REGISTRAR PROVEEDOR
                      </v-btn>
                    </v-col>
                    
                      <v-col cols="2">
                        <v-text-field class="resaltar" background-color="light-blue lighten-4" outlined label="Total Q." dense :value="sumatoria || 0.0 | redondear" disabled></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field class="resaltar" background-color="light-blue lighten-4"  outlined label="Descuento Q." dense :value="totalDescuento || 0.0" disabled></v-text-field>
                      </v-col> 
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="7" class="mt-2">
              <v-text-field
              autofocus
                append-icon="mdi-barcode-scan"
                outlined
                label="Buscar Código"
                dense
                v-model="codigoproducto"
                @keyup.enter="buscarProducto"
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-btn
                class="ma-2"
                outlined
                color="indigo"
                @click="modalproductos=true"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="4" v-show="sumatoria > 0">
                <v-btn class="ma-2" color="green"  @click="createCompra" dark large>
                  <v-icon class="mdi-24px" left>mdi-check-bold</v-icon>
                  GENERAR
                </v-btn>
                <v-btn class="ma-2" color="blue-grey darken-2" dark large @click="carrito.splice(0, carrito.length)">
                <v-icon left>mdi-close</v-icon> VACIAR
              </v-btn>
            </v-col>
          </v-row>
          <v-row id="ticket">
            <v-col>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Descripción</th>
                      <th class="text-center" width="8%">Cantidad</th>
                      <th class="text-center" width="8%">Precio Compra</th>
                      <th class="text-center" width="8%">Descuento</th>
                      <th class="text-center" width="16%">Subtotal</th>
                      <th class="text-center" width="5%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in carrito"
                      :key="item.idarticulo"
                      class="text-center"
                    >
                      <td class="text-left">{{ item.nombre }}</td>
                      <td>
                        <v-text-field
                          v-model="item.cantidad"
                          @change="calculos(item)"
                          dense
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="item.preciocompra"
                          @change="calculos(item)"
                          dense
                        ></v-text-field>
                      </td>
                      <td class="text-center">
                        <v-text-field
                          class="text-center"
                          v-model="item.descuento"
                          @change="calculos(item)"
                          dense
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          :value="
                            (item.cantidad * item.preciocompra - item.descuento)
                              | redondear
                          "
                          dense
                          readonly
                        ></v-text-field>
                      </td>

                      <td>
                        <v-btn icon @click="removeItemCart(item)" dense
                          ><v-icon color="red">mdi-close-box</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-card>
      </v-col>
    </v-row>
    <!-- Modal Seleccionar Producto -->
    <v-dialog v-model="modalproductos" transition="dialog-bottom-transition" width="80%">
      <v-card>
        <v-card-title class="headline blue text-white">
          <v-icon color="white mdi-24px">mdi-account-circle</v-icon>
          <v-divider class="mx-4" vertical></v-divider>
          Seleccione Productos
        </v-card-title>

        <v-card-text>
         <v-row>
            <v-col cols="12" style="background-color: #F5F5F5;">
              <v-card>
                
                <v-card-title>
                  <v-text-field
                    v-model="search"
                    prepend-inner-icon="mdi-magnify"
                    label="Buscar producto...."
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  dense
                  :headers="headers"
                  :items="getAllProductos"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      icon
                      color="blue"
                      @click="pusCarrito(item)"
                    >
                      <v-icon>mdi-plus-box</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
         </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--DIALOG PROCESANDO DATA-->
    <v-dialog v-model="procesardatos" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando Factura...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import currency from "@/utils/currency.js";
import Swal from "sweetalert2";
import axios from "axios";
import findClienteSat from "../Personas/utils/find.cliente";
//import moment from 'moment'
import moment from "moment-timezone";
moment.tz.setDefault("America/Guatemala");
export default {
  name: "FacturasCompras",
  data() {
    return {
      codigoproducto: "",
      procesardatos: false,
      search: "",
      modalproductos: false,
      tipodocumentos: ["Factura Electronica", "Factura","Factura Cambiaria","Recibo","Otro"],
      proveedorEncontrado: true,
      headers: [
        { text: "Cod.", align: "center", value: "codigo" },
        { text: "Nombre", value: "nombre" },
        { text: "Precio Compra", align: "center", value: "preciocompra" },
        { text: "Actions", align: "center", value: "actions", sortable: false },
      ],
      carrito: [],
      editedItemProveedor: {
        nombre: "CONSUMIDOR FINAL",
        nit: "CF",
        direccion: "JALAPA",
      },
      defaultItemProveedor:{
        nombre: "CONSUMIDOR FINAL",
        nit: "CF",
        direccion: "JALAPA",
      },
      carritoObj:{
        cantidad:1,
        preciocompra:0,
        descuento:0,
        precioventa:0,
        total:0,
        idarticulo:1,
      },
      cleancarritoObj:{
        cantidad:1,
        preciocompra:0,
        descuento:0,
        precioventa:0,
        total:0,
        idarticulo:1,
      },
      editedItem: {
        idpersona: 1,
        idusuario: 1,
        cliente: "CONSUMIDOR FINAL",
        numero: 1,
        idestablecimiento:1,
        serie: "",
        descuento: 0,
        total: 0,
        tipo: "Compra",
        documento: "Factura Electronica"
      },
      defaultItem: {
        idpersona: 1,
        idusuario: 1,
        cliente: "CONSUMIDOR FINAL",
        numero: 1,
        idestablecimiento:1,
        serie: "",
        descuento: 0,
        total: 0,
        tipo: "Compra",
        documento: "Factura Electronica",
      },
      idfactura:false,
    };
  },
  async created() {
    this.editedItem.idestablecimiento =  parseInt( localStorage.getItem('idestablecimiento') )
    await this.initialize();
  },
  computed: {
    ...mapGetters(['getAllProductos','getTokenUser','getProductosActivos']),
    sumatoria() {
      return currency(
        this.carrito.reduce(
          (total, current) =>
            total +
            (current.cantidad * current.preciocompra - current.descuento),
          0
        )
      );
    },
    totalDescuento() {
      return currency(this.carrito.reduce((descuento, current) => descuento + parseFloat(current.descuento),0));
    },
    getEstablecimientos(){
      return this.$store.getters.getEstablecimientosActivas
    }
  },
  methods: {
    calculos(item) {

      const index = this.carrito.indexOf(item)
      this.carrito[index].total = (parseFloat(item.cantidad)*parseFloat(item.preciocompra))-parseFloat(item.descuento)
      
    //Validamos que el descuento no este vacio
      if(this.carrito[index].descuento.length==0){
        item.descuento=0;}
        //Validamos que la cantidad no este vacia
      if(item.cantidad<1){
        item.cantidad=1} 

    },
    async initialize() {
      await this.$store.dispatch("setProductos");
      await this.$store.dispatch('setExistencias',this.editedItem.idestablecimiento)   

      await this.$store.dispatch('setAllEstablecimientos')  
      await this.$store.dispatch("setClientes");
      await this.$store.dispatch('setAllCompras');  
      this.$store.dispatch("setNavigation");
    },
   async setIdEstablecimiento(){
        localStorage.setItem('idestablecimiento',this.editedItem.idestablecimiento)
        await this.$store.dispatch('setExistencias',this.editedItem.idestablecimiento)   

    },
    async createCompra(){
        //POST VENTA
        if(!this.procesardatos){
          this.procesardatos = true;
          this.editedItem.total = this.sumatoria
          const respuesta = await this.$store.dispatch("createVenta",this.editedItem)
          if(respuesta.status>299)this.errorSwal("Error al registrar la venta")
          
          this.idfactura = respuesta.data.idfactura
          await this.createDetalleFactura()
          this.alertDone('Compra Registrada')
          this.$router.push('/compras')
          await this.$store.dispatch("setProductos");
        }
    },
    async createDetalleFactura(){
      
      const datos = []
       this.carrito.forEach(async item=>{
         item.idfactura = parseInt(this.idfactura)
          //Actualizamos el Stock 
           await this.precioPromedioProducto(item);

          datos.push(item)
       })

       await this.postFacturaDetalle()
    },

    async postFacturaDetalle(){
      
      try {
       await axios.post(`${this.$store.state.urlapi}/facturadetalles/`,this.carrito,this.getTokenUser) 
         this.procesardatos = false;
         this.clearData()
         this.modalProveedor=false;

      } catch (error) {
        console.log(error)
        this.errorSwal('Error al registrar Compra')
      }
    },
    clearData(){
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItemProveedor = Object.assign({}, this.defaultItemProveedor);
      this.carrito=[]
    },
    async buscarCliente() {
      const data = this.$store.getters.getClientes(
        this.editedItemProveedor.nit.toUpperCase()
      );
      if (data) {
        this.proveedorEncontrado = true;
        this.editedItem.idpersona = data.idpersona;
        this.editedItem.cliente = data.nombre;
        this.editedItemProveedor.nombre = this.editedItem.cliente;
        this.editedItemProveedor.direccion = data.direccion;
      } else {
        this.proveedorEncontrado = false;
        const cliente = await findClienteSat(
          this.editedItemProveedor.nit.toUpperCase()
        );
        this.editedItemProveedor.nombre = cliente;
      }
    },
    async createCliente() {
      await this.$store.dispatch("createCliente", this.editedItemProveedor);
      //Recargamos el inicio para obtener los clientes
      await this.initialize();
      //Buscamos nuevamente el cliente invocando al metodo buscarCliente
      await this.buscarCliente();
    },
    //METODOS PARA AGREGAR Y ELIMINAR ELEMENTOS DEL CARRITO 
    pusCarrito(item) {
      
      const articulo = this.carrito.find(elemento=>elemento.idarticulo ==item.idarticulo );

       const producto = this.getProductosActivos.find(elemento=>elemento.articulo.idarticulo ===item.idarticulo && elemento.establecimiento.idestablecimiento === this.editedItem.idestablecimiento ) 
       
       //Agregamos el id del Stock al objeto
       if (producto)  this.carritoObj.id = producto.id
      

      //Si es diferente de vacio que inserte el producto
      if (!articulo) {
        this.carritoObj.nombre= item.nombre
        this.carritoObj.cantidad= parseInt(1)
        this.carritoObj.preciocompra=parseFloat(item.preciocompra)
        this.carritoObj.descuento= parseFloat(0.00)
        this.carritoObj.precioventa=parseFloat(item.preciosugerido)
        this.carritoObj.total=(this.carritoObj.cantidad*this.carritoObj.precioventa)
        this.carritoObj.idarticulo=parseInt(item.idarticulo)
        this.carrito.push(this.carritoObj);
      } else {
        this.addItemCart(articulo,item);
      }
      this.carritoObj = Object.assign({}, this.cleancarritoObj)      
    },
    addItemCart(articulo) {
     
      
        articulo.cantidad++

    },
    removeItemCart(item) {
      const index = this.carrito.indexOf(item);
      this.carrito.splice(index, 1);
    },
    async precioPromedioProducto(item){
       
        if(!item.id){

          const existencias={
  
          stockminimo: 1,
          stockactual: item.cantidad,
          articulo: item.idarticulo,
          establecimiento: this.editedItem.idestablecimiento
        }

          await this.$store.dispatch('postExistencias',existencias)
        }else{
            const producto = await this.getProductosActivos.find(elemento=>elemento.articulo.idarticulo ===item.idarticulo) 

            const precioCantidad = (parseFloat(item.cantidad)*parseFloat(item.preciocompra)) + (parseFloat(producto.stockactual)*parseFloat(producto.preciocompra))
            const nuevoStock = parseFloat(item.cantidad)+parseFloat(producto.stockactual)

            if(producto.stockactual>0){
              const nuevoPrecioCompra = precioCantidad/nuevoStock;
              producto.stockactual = nuevoStock;
              producto.preciocompra = nuevoPrecioCompra;
            }else{
              producto.stockactual = parseFloat(item.cantidad);
              producto.preciocompra = parseFloat(item.preciocompra);
            }
            
            //Parsear Informacion
            delete producto.stockminimo 
            delete producto.preciosugerido
            delete producto.preciominimo
            delete producto.idcategoria
            const idarticulo = item.id

            delete producto.articulo
            delete producto.establecimiento

            await axios.patch(`${this.$store.state.urlapi}/articulostock/${idarticulo}`,producto,this.getTokenUser)
        
        }

      
       
      
       
    
    },
    buscarProducto() {
      const producto = this.getAllProductos.filter( (item) => item.codigo == this.codigoproducto);
      
      if (producto[0]) {
        this.pusCarrito(producto[0]);
      } else {
        this.infoSwal("Error", "El producto no se encontró");
      }
      this.codigoproducto = '';
    },
    //Notificaciones Swal
    alertDone(message) {
      Swal.fire({
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
    },
    errorSwal(message) {
      Swal.fire({
        icon: "error",
        title: message,
        text: "La factura no pudo ser procesada intentelo mas tarde",
      });
    },
    infoSwal(message, texto) {
      Swal.fire({
        icon: "info",
        title: message,
        text: texto,
      });
    },
  },
  filters: {
    redondear: function (value) {
      if (!value) return "";
      value = parseFloat(value);
      return currency(value, { precision: 2 });
    },
  },
};
</script>
<style scoped>
.main{
  margin-top:-10px;
  height: 100vh;
}
.cliente{
  color: #3F51B5;
  font-size: 1.5em;
}
.resaltar{
  font-size: 25px;
  font-weight: 500;
}

</style>